export default function PHP_count_chars() {
  return (
    <div>
      <h1>PHP_count_chars</h1>
    </div>
  );
}
